import { Typography } from '@/components';
import { TextStyles } from '@/constants';
import { Grow } from '@/modules/pmt/components/Grow';
import ArrowDownIcon from '@/public/images/icons/arrow_down.svg';
import ArrowUpIcon from '@/public/images/icons/arrow_up.svg';
import styled from 'styled-components';

export const Growable = styled(Grow)<{ showToggle: boolean }>({ width: '100%' });

export const GrowableActionContainer = styled.div<{ isGrown: boolean }>(({ theme, isGrown }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  borderTop: `1px solid ${theme.colors.surface05}`,
  paddingTop: theme.spacing[16],
  // KNOWN ISSUE of grow
  marginTop: !isGrown ? theme.spacing[8] : 0,
}));

export const GrowableAction = styled.button(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  columnGap: theme.spacing[8],
  cursor: 'pointer',
  backgroundColor: 'transparent',
  border: 'none',
  padding: 0,
}));

export const ActionTitle = styled(Typography).attrs({
  variant: TextStyles['Body Text Small'],
})(({ theme }) => ({
  color: theme.colors.mediumEmphasisBlack,
}));

interface IArrowIcon {
  isOpen: boolean;
  className?: string;
}

const ArrowIcon = ({ isOpen, className }: IArrowIcon) => {
  const Arrow = isOpen ? ArrowUpIcon : ArrowDownIcon;
  return <Arrow className={className} />;
};

export const GrowableArrow = styled(ArrowIcon)(({ theme }) => ({
  fill: theme.colors.mediumEmphasisBlack,
}));
